export default "/images/ireview-hover-light.svg?25d1f3de519ee2ec899be6f297a567d7";